import { inject } from 'vue';
import { DriveServiceKey } from './keys';
import type { DriveService } from './types';

/** Drive open/save/share when running inside the Connect shell; otherwise `undefined`. */
export function useDrive(): DriveService | undefined {
  return inject(DriveServiceKey, undefined);
}
